import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const RoutePageView = () => {
    const { pathname } = useLocation();
    const first = useRef(true);
    useEffect(() => {
        if (first.current) {
            first.current = false; // initial load PageView already fired by base snippet
        } else if (typeof window.fbq === "function") {
            window.fbq("track", "PageView");
        }
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

export default RoutePageView;
